import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import uploadImage from "../../images/upload-image.jpg";
import { CreateNewCategory } from "../../redux/Slices/CategorySlice";
import notify from "../UseNotification";

const UseAddCategory = () => {
  const dispatch = useDispatch();
  const { AddCategory } = useSelector((state) => state.CategoryReducer);
  const [CategoryImg, setCategoryImg] = useState(uploadImage);
  const [Loading, setLoading] = useState(true);
  const [CategoryName, setCategoryName] = useState("");
  const [categoryImgPath, setCategoryImgPath] = useState();
  const [isPress, setIspress] = useState(false);
  const [isValidate, setIsValidate] = useState(false);


  // to handle save category name
  const SetCategoryName = (e) => {
    setCategoryName(e.target.value);
  };

  // handle category image
  const CategoryImageHandle = (e) => {
    if (e.target.files && e.target.files[0]) {
      setCategoryImg(URL.createObjectURL(e.target.files[0]));
      setCategoryImgPath(e.target.files[0]);
    }
  };

  // vaidate category name
  const ValidateCategoryName = (e) => {
    if (e.target.value === "") {
      notify("category name must at least 3 character", "error")
    }
  }

  // validate category image
  const ValidateCategoryImage = () => {
    if (!categoryImgPath) {
      notify("you must choose category image", "error")
    }
  }

  // to handle disable submit button
  useEffect(() => {
    if (CategoryName && categoryImgPath && CategoryName.length >= 3 && categoryImgPath.name != "") {
      setIsValidate(true)
    } else {
      setIsValidate(false)
    }
  }, [CategoryName, categoryImgPath])

  // handle submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIspress(true);
    if (!categoryImgPath) {
      notify("please the brand image", "error")
      return;
    }

    if (CategoryName.length < 3) {
      notify("Category Name at least 3 character", "error")
      return;
    }
    const formData = new FormData();
    formData.append("name", CategoryName);
    formData.append("image", categoryImgPath);
    setLoading(true)
    await dispatch(CreateNewCategory(formData));
    setLoading(false)
  };


  // handle response request
  useEffect(() => {
    if (Loading === false) {
      if (AddCategory.status === 201) {
        notify("Success", "success");
        setTimeout(() => { window.location.reload(false) }, 1000)

      } else if (AddCategory && AddCategory.response) {
        if (AddCategory && AddCategory.response.status === 500) {
          notify("Please complete the data", "error")
        } else if (AddCategory && AddCategory.response.status === 401) {
          notify("Please login to can add new brand", "error")
        }
      }
    }
  }, [Loading]);




  return [
    ValidateCategoryName,
    ValidateCategoryImage,
    isValidate,
    Loading,
    CategoryImg,
    CategoryName,
    SetCategoryName,
    isPress,
    CategoryImageHandle,
    handleSubmit,
  ];
};

export default UseAddCategory;
